import parser from 'ua-parser-js';

export interface ApiClientOptions {
  method?: 'GET' | 'POST' | 'DELETE' | 'PATCH' | 'PUT';
  headers?: any;
  withApiHost?: boolean;
  body?: string | FormData | File;
  credentials?: RequestCredentials;
}

export type TApiAuthClient = {
  headers: HeadersInit;
  setAccessToken: (token: string) => void;
  fetch: (endpoint: string, options?: ApiClientOptions | undefined) => Promise<Response>;
};

class EventDispatcher {
  queue: any[];
  csrfToken: any;
  endpoint!: string;
  userId!: string;
  product!: string;
  isInit!: boolean;
  credentials?: RequestCredentials;
  apiAuthClient!: TApiAuthClient;

  constructor() {
    this.queue = [];
    this.csrfToken = localStorage.getItem('csrfToken');
  }

  init({
    endpoint,
    product,
    userId,
    credentials,
    apiAuthClient,
  }: {
    endpoint: string;
    product: string;
    userId: string;
    credentials: RequestCredentials;
    apiAuthClient: TApiAuthClient;
  }) {
    this.endpoint = endpoint || '/api/v1/events/client';
    this.credentials = credentials || 'same-origin';
    this.userId = userId;
    this.product = product;
    this.isInit = true;
    this.apiAuthClient = apiAuthClient;

    const id = setInterval(() => {
      this.dispatchEvents();
    }, 2000);

    return () => clearInterval(id);
  }

  dispatchEvents() {
    if (!this.queue.length) {
      return;
    }

    this.apiAuthClient.fetch(this.endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-CSRFToken': this.csrfToken,
      },
      credentials: this.credentials,
      body: JSON.stringify(this.queue),
    });

    this.queue = [];
  }

  event({
    name,
    data,
  }: {
    name: string;
    data?: {
      [key: string]: any;
    };
  }) {
    const timeStamp = Date.now();

    const { href, pathname } = window?.location ?? {};
    const { browser, device, os, engine } = parser(window?.navigator.userAgent);

    const eventData = {
      userId: this.userId,
      product: this.product,
      name,
      src: window.GLOAT_EXTERNAL_SOURCE,
      browser,
      device,
      engine,
      os,
      timeStamp,
      pathname,
      url: href,
      referrer: document.referrer,
      externalSource: (window as any).isUnderTeams ? 'teams' : 'web',
      extraData: {
        ...data,
      },
    };

    this.queue = [...this.queue, eventData];
  }

  render() {
    return null;
  }
}

export default new EventDispatcher();
